// extracted by mini-css-extract-plugin
module.exports = {"right":"styles_right__38oA2"};